import { useEffect, useState, useRef } from 'react';
import { config } from '../util/config';

const DISAMBIGUATION_DESCRIPTION = 'Topics referred to by the same term';

const usePageSearch = query => {
  const [results, setResults] = useState({ timestamp: 0, results: [] });
  const [loading, setLoading] = useState(false);
  const latestTimestampRef = useRef(0);

  useEffect(() => {
    if (query) {
      const timeout = setTimeout(() => {
        const timestamp = Date.now();
        latestTimestampRef.current = timestamp;
        setLoading(true);

        fetch(config.WIKI_REST_URL + '/search/title?limit=10&q=' + query)
          .then(res => res.json())
          .then(data => {
            if (latestTimestampRef.current > timestamp) return;
            setResults({
              timestamp: timestamp,
              results: data.pages
                .filter(p => p.description !== DISAMBIGUATION_DESCRIPTION)
                .map(r => ({ id: r.id, title: r.title, description: r.description }))
            });
            setLoading(false);
          })
          .catch(err => {
            console.error('Error fetching wiki pages', err);
          })
      }, 250);
      return () => clearTimeout(timeout);
    }
  }, [query]);

  return [results.results, loading];
}

export default usePageSearch;
